module.exports = __webpack_public_path__ + "img/news4.bb2f30c0.png";